import './styles.scss'

export const Asterisk = () => <span className="asterisk">*</span>
